var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "account-page ctsform",
      class: {
        registration_disabled:
          _vm.disableJoin && _vm.brandTemplate === "generic_2"
      }
    },
    [
      _vm.brandTemplate !== "generic_2"
        ? _c(
            "div",
            { staticClass: "closeBtnContainer" },
            [
              _c(
                "v-icon",
                {
                  staticClass: "close",
                  on: {
                    click: function($event) {
                      $event.stopPropagation()
                      return _vm.go2Home()
                    }
                  }
                },
                [_vm._v("close")]
              )
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.brandLayout === "generic" && _vm.brandTemplate === "generic_2"
        ? _c("div", { staticClass: "login_join_links reg_page" }, [
            _c("a", { staticClass: "active" }, [
              _c("span", [_vm._v(_vm._s(_vm.$t("MyAccount.JoinNow")))])
            ]),
            _vm._v(" "),
            _c(
              "a",
              {
                on: {
                  click: function($event) {
                    return _vm.openDialogLogin()
                  }
                }
              },
              [_c("span", [_vm._v(_vm._s(_vm.$t("MyAccount.LogIn")))])]
            )
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.brandKey === "qcasino"
        ? [
            _vm.mobileBigAndBelow
              ? _c("div", {
                  staticClass: "joinusTitle",
                  domProps: {
                    innerHTML: _vm._s(_vm.$t("MyAccount.JoinUs.Title"))
                  }
                })
              : _vm._e(),
            _vm._v(" "),
            _c("div", { staticClass: "acc-header" }, [
              _c("img", {
                attrs: {
                  src: _vm.mediaServer(
                    "/static/brand-img/" +
                      _vm.brandKey +
                      "/account-create-white.svg"
                  ),
                  alt: _vm.brandKey
                }
              }),
              _vm._v(" "),
              _c("h1", [_vm._v(_vm._s(_vm.$t("Account.Join.Heading")))])
            ])
          ]
        : _vm._e(),
      _vm._v(" "),
      _vm.brandKey !== "qcasino"
        ? [
            false
              ? _c("h1", [_vm._v(_vm._s(_vm.$t("Account.Join.Heading")))])
              : _vm._e()
          ]
        : _vm._e(),
      _vm._v(" "),
      _vm.disableJoin && _vm.brandTemplate === "generic_2"
        ? [
            _c("div", { staticClass: "join-message" }, [
              _c("h3", [_vm._v(_vm._s(_vm.$t("JoinDialog.NewCustomer")))]),
              _vm._v(" "),
              _c("p", {
                domProps: { innerHTML: _vm._s(_vm.$t("JoinDialog.Text")) }
              }),
              _vm._v(" "),
              _c("p", { staticClass: "text_21" }, [
                _vm._v(_vm._s(_vm.$t("JoinDialog.Text_21")))
              ])
            ])
          ]
        : _vm._e(),
      _vm._v(" "),
      !_vm.disableJoin
        ? [
            _c(
              "form",
              { attrs: { id: "registrationForm" } },
              [
                _vm.currentStep === 1
                  ? _c("div", { staticClass: "joinusTitle upper" }, [
                      _vm._v(
                        _vm._s(
                          _vm.$t("Account.CreateAccount.Registration.Title")
                        )
                      )
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _vm.currentStep === 2
                  ? _c("div", { staticClass: "joinusTitle upper" }, [
                      _vm._v(
                        _vm._s(
                          _vm.$t(
                            "Account.CreateAccount.Registration.ConfirmIdentity"
                          )
                        )
                      )
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _vm.currentStep === 3
                  ? _c("div", { staticClass: "joinusTitle upper" }, [
                      _vm._v(
                        _vm._s(
                          _vm.$t("Account.CreateAccount.Registration.CreateAcc")
                        )
                      )
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _vm.currentStepState === "entry"
                  ? _c("RegStepCounter", {
                      ref: "RegStep",
                      attrs: {
                        currentStep: _vm.currentStep,
                        currStepTitle: _vm.stepTitle
                      },
                      on: { jump2Step: _vm.jump2Step }
                    })
                  : _c("div", { staticClass: "joinusTitle" }, [
                      _c("p", { staticClass: "correction-title" }, [
                        _vm._v(
                          _vm._s(_vm.$t("Account.CreateAccount.Registration"))
                        )
                      ]),
                      _vm._v(" "),
                      _c("p", { staticClass: "correction-subtitle" }, [
                        _vm._v(
                          _vm._s(_vm.$t("Account.CreateAccount.Correction"))
                        )
                      ]),
                      _vm._v(" "),
                      _c("span", { staticClass: "mag_glass_correction" })
                    ]),
                _vm._v(" "),
                _vm.currentStep === 1
                  ? _c("div", { staticClass: "joinusTitle sub" }, [
                      _vm._v(
                        _vm._s(
                          _vm.$t("Account.CreateAccount.Registration.SetupAcc")
                        )
                      )
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _vm.currentStep === 2
                  ? _c("div", { staticClass: "joinusTitle sub" }, [
                      _vm._v(
                        _vm._s(
                          _vm.$t(
                            "Account.CreateAccount.Registration.SetupIdentity"
                          )
                        )
                      )
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _vm.currentStep === 3
                  ? _c("div", { staticClass: "joinusTitle sub" }, [
                      _vm._v(
                        _vm._s(
                          _vm.$t(
                            "Account.CreateAccount.Registration.AlmostDone"
                          )
                        )
                      )
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _c(
                  "div",
                  [
                    _c(_vm.currentComponent, {
                      ref: "regComp",
                      tag: "component",
                      attrs: {
                        currentStep: _vm.currentStep,
                        currentStepState: _vm.currentStepState,
                        registrationDetails: _vm.registrationDetails,
                        regError: _vm.regError
                      },
                      on: {
                        go2SomeStep: _vm.go2Step,
                        updateRegError: function($event) {
                          return _vm.updateRegError()
                        }
                      }
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _vm.brandTemplate !== "generic_2" &&
                _vm.currentStepState === "entry" &&
                (_vm.currentStep === 1 || _vm.currentStep === 2)
                  ? _c("p", { staticClass: "next-text" }, [
                      _vm._v(_vm._s(_vm.$t("Account.JoinUs.Next")))
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "form-actions" },
                  [
                    _vm.currentStepState === "entry" &&
                    (_vm.currentStep === 1 || _vm.currentStep === 2)
                      ? _c(
                          "v-btn",
                          {
                            attrs: { color: "success", "x-large": "" },
                            on: {
                              click: function($event) {
                                $event.stopPropagation()
                                return _vm.go2Step()
                              }
                            }
                          },
                          [
                            _c("span", {
                              domProps: { innerHTML: _vm._s(_vm.stepSubtitle) }
                            })
                          ]
                        )
                      : _c(
                          "v-btn",
                          {
                            attrs: { color: "success", "x-large": "" },
                            on: {
                              click: function($event) {
                                $event.stopPropagation()
                                return _vm.register()
                              }
                            }
                          },
                          [
                            _vm.currentStepState === "entry"
                              ? _c("span", [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t("Account.CreateAccount.Reg4Step")
                                    )
                                  )
                                ])
                              : _c("span", [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t("Account.CreateAccount.ReSubmit")
                                    ) + " "
                                  )
                                ])
                          ]
                        ),
                    _vm._v(" "),
                    _vm.currentStepState === "entry" &&
                    _vm.currentStep === 3 &&
                    _vm.isAttestationsPrepopluated
                      ? _c("div", { staticClass: "accept-tc" }, [
                          _vm._v(_vm._s(_vm.$t("AcceptT&C")))
                        ])
                      : _vm._e()
                  ],
                  1
                ),
                _vm._v(" "),
                _vm.brandKey === "sb" && _vm.state === "NJ"
                  ? _c("div", { staticClass: "rg-joinus" }, [
                      _c("span", { staticClass: "header-txt" }, [
                        _vm._v(
                          _vm._s(_vm.$t("JoinNow.InfoMessage." + _vm.state))
                        )
                      ])
                    ])
                  : _vm._e()
              ],
              1
            ),
            _vm._v(" "),
            _vm.showDialog
              ? _c(
                  "ProcessingDialog",
                  {
                    ref: "refProcessingDialog",
                    attrs: {
                      isDialogPersistent: true,
                      isProcessing: _vm.isProcessing,
                      isSuccess: !_vm.transactionError,
                      processingTitle: _vm.$t(
                        "Account.Join.Dialog.Processing.Title"
                      ),
                      processingText: _vm.$t(
                        "Account.Join.Dialog.Processing.Text"
                      ),
                      successTitle: _vm.$t("Account.Join.Dialog.Success.Title"),
                      successText: _vm.$t("Account.Join.Dialog.Success.Text"),
                      errorTitle: _vm.$t("Account.Join.Dialog.Error.Title"),
                      closeBtnText: _vm.$t("ProcessingDialog.CloseButtonText")
                    },
                    on: { close: _vm.closeRegistrationDialog },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "title",
                          fn: function() {
                            return [
                              _c("v-spacer", { staticClass: "spacer" }),
                              _vm._v(" "),
                              _vm.isProcessing
                                ? _c("div", [
                                    _c("span", [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t(
                                            "Account.Join.Dialog.Processing.Title"
                                          )
                                        )
                                      )
                                    ])
                                  ])
                                : _c("div", [
                                    !_vm.transactionError
                                      ? _c(
                                          "span",
                                          {
                                            attrs: {
                                              id: "dialog_success_title"
                                            }
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$t(
                                                  "Account.Join.Dialog.Success.Title"
                                                )
                                              )
                                            )
                                          ]
                                        )
                                      : _c(
                                          "span",
                                          {
                                            staticClass: "red--text",
                                            attrs: { id: "dialog_error_title" }
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$t(
                                                  "Account.Join.Dialog.Error.Title"
                                                )
                                              )
                                            )
                                          ]
                                        )
                                  ])
                            ]
                          },
                          proxy: true
                        },
                        {
                          key: "actions",
                          fn: function() {
                            return [
                              _c("v-spacer", { staticClass: "spacer" }),
                              _vm._v(" "),
                              _c(
                                "v-btn",
                                {
                                  staticClass: "closeButtonProcessingDialog",
                                  attrs: {
                                    flat: "",
                                    disabled: _vm.isProcessing
                                  },
                                  on: { click: _vm.closeProcessingDialog }
                                },
                                [
                                  _c(
                                    "span",
                                    { attrs: { id: "qa-closeBtnText" } },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t(
                                            "ProcessingDialog.CloseButtonText"
                                          )
                                        )
                                      )
                                    ]
                                  )
                                ]
                              )
                            ]
                          },
                          proxy: true
                        }
                      ],
                      null,
                      false,
                      3901588474
                    ),
                    model: {
                      value: _vm.dialog,
                      callback: function($$v) {
                        _vm.dialog = $$v
                      },
                      expression: "dialog"
                    }
                  },
                  [
                    _vm._v(" "),
                    _c(
                      "div",
                      { attrs: { slot: "text-error" }, slot: "text-error" },
                      [
                        _vm.brandKey !== "sb"
                          ? _c(
                              "p",
                              { staticClass: "generic-icon-note" },
                              [
                                _c(
                                  "v-icon",
                                  {
                                    staticClass: "mr-1",
                                    attrs: { color: "error" }
                                  },
                                  [_vm._v("error")]
                                ),
                                _c("span", [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t("Account.Join.Dialog.Error.Text")
                                    )
                                  )
                                ])
                              ],
                              1
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _c("p", { staticClass: "response-error" }, [
                          _vm._v(_vm._s(_vm.transactionError))
                        ]),
                        _vm._v(" "),
                        _vm.brandKey !== "sb" ||
                        (_vm.brandKey === "sb" && !_vm.duplicateEmail)
                          ? _c("p", {
                              domProps: {
                                innerHTML: _vm._s(
                                  _vm.$t(
                                    "Account.Join.Dialog.Error.Text.ContactSupport"
                                  )
                                )
                              }
                            })
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.brandKey === "sb" && _vm.duplicateEmail
                          ? _c("p", {
                              domProps: {
                                innerHTML: _vm._s(
                                  _vm.$t(
                                    "Account.Join.Dialog.Error.Text.DuplicateEmail.ContactSupport"
                                  )
                                )
                              }
                            })
                          : _vm._e()
                      ]
                    )
                  ]
                )
              : _vm._e()
          ]
        : _vm._e(),
      _vm._v(" "),
      _vm.mobileBigAndBelow &&
      _vm.brandLayout === "generic" &&
      _vm.brandTemplate === "generic_2"
        ? _c("div", { staticClass: "login-footer" }, [
            _c("div", { staticClass: "login-footer-title" }, [
              _vm._v(_vm._s(_vm.$t("LoginFooter.PlayResponsiblyTitle")))
            ]),
            _vm._v(" "),
            _c("div", {
              staticClass: "login-footer-desc",
              domProps: {
                innerHTML: _vm._s(_vm.$t("LoginFooter.PlayResponsiblyDesc"))
              }
            })
          ])
        : _vm._e()
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-62e36ae6", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-62e36ae6","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/account/Registration/Registration.vue
// module id = null
// module chunks = 